import { useGetStockAdjustmentsQuery } from '@/features/slice/inventory';

export const useStockAdjustmentList = () => {
    const { data, isLoading, isError, isFetching, error } =
        useGetStockAdjustmentsQuery({});

    return {
        data,
        isLoading,
        isError,
        isFetching,
        error,
    };
};
